import React from 'react';

const fmtCOP = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v || 0);

// Franja fija al pie de la pantalla, siempre visible mientras se hace scroll (en cualquier tamaño de pantalla).
export default function BuyStickyButton({ precio, precioDescuento, buttonText, onClick, disabled }) {
  const tieneDescuento = precioDescuento && precioDescuento < precio;
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff',
      borderTop: '1px solid rgba(28,58,30,0.1)', padding: '12px 16px',
      display: 'flex', alignItems: 'center', gap: 14, zIndex: 200,
      boxShadow: '0 -4px 16px rgba(0,0,0,0.06)',
    }}>
      <div style={{ flexShrink: 0 }}>
        {tieneDescuento && <div style={{ fontSize: 12, color: 'var(--ink-faint)', textDecoration: 'line-through' }}>{fmtCOP(precio)}</div>}
        <div style={{ fontWeight: 900, fontSize: 18, color: 'var(--forest)' }}>{fmtCOP(tieneDescuento ? precioDescuento : precio)}</div>
      </div>
      <button onClick={onClick} disabled={disabled} style={{
        flex: 1, padding: '14px', fontSize: 15, fontWeight: 800, borderRadius: 'var(--r-lg)', border: 'none',
        background: disabled ? '#ccc' : '#1C3A1E', color: '#9FBE6A', cursor: disabled ? 'not-allowed' : 'pointer',
        maxWidth: 420,
      }}>
        {buttonText || 'COMPRAR AHORA'}
      </button>
    </div>
  );
}
